var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.92951 3.55489C8.32097 2.17418 11.3789 2.99356 12.7596 5.38502C14.1404 7.77649 13.321 10.8344 10.9295 12.2151C8.53805 13.5959 5.4801 12.7765 4.09938 10.385C3.72667 9.73946 3.51464 9.04661 3.44999 8.35163C3.42442 8.07668 3.18079 7.87451 2.90583 7.90009C2.63088 7.92566 2.42872 8.16929 2.45429 8.44425C2.53202 9.27987 2.78711 10.1121 3.23336 10.885C4.89021 13.7548 8.55976 14.738 11.4295 13.0812C14.2993 11.4243 15.2825 7.75478 13.6257 4.88502C11.9688 2.01527 8.29927 1.03202 5.42951 2.68887L5.92951 3.55489Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66263 4.8247L4.69639 1.41907C4.59041 1.23551 4.31842 1.25884 4.24525 1.45777L3.185 4.34032C3.1311 4.48685 3.22321 4.64638 3.37705 4.67297L6.40355 5.19604C6.61241 5.23214 6.76861 5.00826 6.66263 4.8247Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoButton);
export default __webpack_public_path__ + "static/media/undoButton.3e3d3cd4172768a7029d6335e503ac06.svg";
export { ForwardRef as ReactComponent };